import React, { useMemo } from "react";
import "./ScheduleTable.css";

const SHORT_DAYS = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];

export default function ScheduleTable({ schedules }) {
  const { days, maxBlocks } = useMemo(() => {
    const grouped = {};
    for (const s of schedules) {
      if (!grouped[s.dayOfWeek]) grouped[s.dayOfWeek] = [];
      grouped[s.dayOfWeek].push(s);
    }
    const sortedDays = Object.keys(grouped)
      .map(Number)
      .sort((a, b) => (a || 7) - (b || 7));
    let max = 0;
    for (const d of sortedDays) {
      if (grouped[d].length > max) max = grouped[d].length;
    }
    return { days: sortedDays.map((d) => ({ day: d, blocks: grouped[d] })), maxBlocks: max };
  }, [schedules]);

  if (!schedules?.length) return null;

  return (
    <div className="st-wrap">
      <table className="st-table" style={{ minWidth: days.length * 100 }}>
        <thead>
          <tr>
            {days.map(({ day }) => (
              <th key={day} className="st-th">
                {SHORT_DAYS[day]}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: maxBlocks }, (_, rowIdx) => (
            <tr key={rowIdx}>
              {days.map(({ day, blocks }) => (
                <td key={day} className="st-td">
                  {blocks[rowIdx] ? (
                    <span className="st-cell">
                      {blocks[rowIdx].startTime} - {blocks[rowIdx].endTime}
                    </span>
                  ) : null}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
